import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  documents: [],
  total: 0,
  document: null,
  currentVersion: null,
  versions: [],
  isFetching: false,
  error: false,
};

const normalizeDocumentsList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  if (Array.isArray(payload?.documents)) {
    return payload.documents;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    documentsStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    documentsSuccess: (state, action) => {
      const documents = normalizeDocumentsList(action.payload);

      state.documents = documents;
      state.total =
        Number(
          action.payload?.total ??
            action.payload?.pagination?.total ??
            documents.length,
        ) || 0;
      state.isFetching = false;
      state.error = false;
    },
    documentsFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    documentDetailStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    documentDetailSuccess: (state, action) => {
      state.document = action.payload?.document ?? null;
      state.currentVersion = action.payload?.current_version ?? null;
      state.versions = Array.isArray(action.payload?.versions)
        ? action.payload.versions
        : [];
      state.isFetching = false;
      state.error = false;
    },
    documentDetailFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    clearDocumentDetail: (state) => {
      state.document = null;
      state.currentVersion = null;
      state.versions = [];
    },
    clearDocumentError: (state) => {
      state.error = false;
    },
  },
});

export const {
  documentsStart,
  documentsSuccess,
  documentsFailure,
  documentDetailStart,
  documentDetailSuccess,
  documentDetailFailure,
  clearDocumentDetail,
  clearDocumentError,
} = documentsSlice.actions;

export default documentsSlice.reducer;
